import React from 'react';
import { useSelector } from 'react-redux';
import { getOrderingSystem } from '../../../../../../selectors/tools';
import SearchResultsShopify from './SearchResultsShopify/SearchResultsShopify';
import SearchResultsBigCommerce from './SearchResultsBigCommerce/SearchResultsBigCommerce';
import SearchResultsCommon from './SearchResultsCommon/SearchResultsCommon';
import SearchResultsDefault from './SearchResultsDefault/SearchResultsDefault';
import SearchResultsAmazon from './SearchResultsAmazon/SearchResultsAmazon';

export const SearchResults = () => {
  const orderingSystem = useSelector(getOrderingSystem);

  const componentMap = {
    common: <SearchResultsCommon />,
    shopify: <SearchResultsShopify />,
    amazon: <SearchResultsAmazon />,
    bigCommerce: <SearchResultsBigCommerce />,
    default: <SearchResultsDefault />,
  };

  return componentMap[orderingSystem] || componentMap.default;
};
